/** 샵관리 — 회원권관리. 신규 회원권은 매출(회원권)이 자동 생성되고, 환불 처리하면 매출이 환불 표시된다. */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import {
  loadTable, persistTable, createUid, num, today, customerOptions, serviceOptions,
  PASS_STATUS_OPTIONS, passRemain, syncPassSales,
} from 'shop/shopStore';
import { selectField, lockExisting } from 'shop/shopPageHelpers';

const decorate = (tc) => {
  const customers = new Map(loadTable(tc, 'customer').map((c) => [c.customerUid, c]));
  return (p) => ({ ...p, mod: '', remainCnt: passRemain(p), customerNm: customers.get(p.customerUid)?.customerNm || '' });
};

const filter = (rows, v) =>
  rows.filter(
    (r) => r.mod !== 'D'
      && (!v.status || r.status === v.status)
      && (!v.customerUid || r.customerUid === v.customerUid)
  );

const cfg = {
  gridId: 'sh-pass',
  title: '회원권관리',
  uidKey: 'passUid',
  searchDefaults: { status: 'ACTIVE', customerUid: '', keyword: '' },
  searchFields: ({ tc }) => [[
    selectField('customerUid', '고객', customerOptions(tc), '200px'),
    selectField('status', '상태', PASS_STATUS_OPTIONS),
  ]],
  columns: ({ tc }) => [
    lockExisting(hiCol.edComboColumn({ header: '고객', field: 'customerUid', size: 170, required: true, options: customerOptions(tc), align: 'left' })),
    lockExisting(hiCol.edComboColumn({ header: '서비스', field: 'serviceUid', size: 190, required: true, options: serviceOptions(tc), align: 'left' })),
    hiCol.edNumberColumn({ header: '총횟수', field: 'totalCnt', size: 80, required: true }),
    hiCol.roNumberColumn({ header: '사용', field: 'usedCnt', size: 70 }),
    hiCol.roNumberColumn({ header: '잔여', field: 'remainCnt', size: 70 }),
    lockExisting(hiCol.edNumberColumn({ header: '결제금액', field: 'price', size: 110, title: '저장 시 매출(회원권)이 자동 생성됩니다' })),
    lockExisting(hiCol.edDateColumn({ header: '결제일', field: 'payDate', size: 120 })),
    hiCol.edDateColumn({ header: '만료일', field: 'expiryDate', size: 120 }),
    hiCol.edCheckboxColumn({ header: '정기결제', field: 'recurringYn', size: 84 }),
    hiCol.edComboColumn({ header: '상태', field: 'status', size: 90, options: PASS_STATUS_OPTIONS }),
    hiCol.edTextColumn({ header: '비고', field: 'remark', size: 180 }),
  ],
  load: (tc) => loadTable(tc, 'pass').map(decorate(tc)),
  filter,
  emptyRow: () => ({
    passUid: createUid('PAS'),
    customerUid: '',
    serviceUid: '',
    totalCnt: 10,
    usedCnt: 0,
    price: 0,
    payDate: today(),
    expiryDate: '',
    recurringYn: 'N',
    status: 'ACTIVE',
    remark: '',
  }),
  validate: (rows, tc) => {
    const used = new Set(loadTable(tc, 'record').map((r) => r.passUid).filter(Boolean));
    const errors = [];
    for (const r of rows) {
      if (r.mod === 'D') {
        if (used.has(r.passUid)) errors.push('시술 이력이 있는 회원권은 삭제할 수 없습니다(환불 처리하세요).');
        continue;
      }
      if (!r.customerUid) errors.push('고객을 선택하세요.');
      if (!r.serviceUid) errors.push('서비스를 선택하세요.');
      if (num(r.totalCnt) <= 0) errors.push('총횟수는 0보다 커야 합니다.');
      if (num(r.totalCnt) < num(r.usedCnt)) errors.push('총횟수는 이미 사용한 횟수보다 적을 수 없습니다.');
    }
    return errors;
  },
  save: (tc, rows, v) => {
    persistTable(tc, 'pass', 'passUid', rows, (r) => filter([r], v).length > 0, (r) => {
      const { remainCnt, customerNm, ...rest } = r;
      const totalCnt = num(r.totalCnt);
      let status = r.status || 'ACTIVE';
      // 횟수를 늘리면 소진 → 이용중, 다 쓰면 이용중 → 소진
      if (status === 'DONE' && num(r.usedCnt) < totalCnt) status = 'ACTIVE';
      if (status === 'ACTIVE' && num(r.usedCnt) >= totalCnt) status = 'DONE';
      return { ...rest, totalCnt, usedCnt: num(r.usedCnt), price: num(r.price), status, recurringYn: r.recurringYn === 'Y' ? 'Y' : 'N' };
    });
    syncPassSales(tc);
  },
};
const PassManage = () => <ShopGridPage cfg={cfg} />;
export default PassManage;
